import React from "react";

const WgsConsentFormComponent = ({ selectedKit }) => {
  const wgsConsent = (
    <>
      <div className="fieldwrap">
        <h2 className="fieldtitle">検査IDの入力</h2>
        <div className="coutionbox">
          18歳未満のお客様は、法定代理人（親権者など）の同意が必要です。検査試料の受領後にご登録いただいたメールアドレスまでご連絡させていただきます。
        </div>
      </div>
      <div className="fieldwrap">
        <div className="consenttext container">
          <span className="bold">遺伝子検査サービス申込同意書 兼 研究協力同意書</span><br />
          <br />
          ジェネシスヘルスケア株式会社　<br />
          遺伝学検査室　御中<br />
          医療法人社団創世会 臨床検査科恵比寿(ジェネシスヘルスケア株式会社提携医療法人)御中（※）<br />
          ※他の提携医療機関が追加された場合には、当該提携医療機関も含むものとします。<br />
          <br />
          本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」）では、申込者のだ液の全ゲノムシーケンス（WGS）を行います。全ゲノムシーケンスに関しては、グローバルスタンダードとされている手法を用いますが、まだ発展段階の技術でもあることから、一層の精度・品質管理、技術・判断・評価の向上を行う観点から、この遺伝子検査サービスは、研究目的でのみ提供しております。従いまして、この遺伝子検査サービスは研究同意をいただいた場合にのみ提供しております（研究同意が必須です）。本遺伝子検査サービスと同時に研究協力に同意いただくことにより、本研究の成果は当社や当社の共同研究先における研究、また、当社の将来的事業を開発するための重要参考資料となることが考えられます。説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご協力いただけるかどうかをご自身でご判断ください。皆様のご理解と研究へのご協力をお願い申し上げます。<br />
          <br />
          私は遺伝子検査サービス申込同意書付属説明書＜遺伝子検査サービスの利用にあたって＞の説明及び（A）研究協力に関する同意文言、（B）検査申込に関する同意文言（以下あわせて「本説明」）を読み、「本遺伝子検査サービス」及び本説明に記載の「本研究」について、以下の内容を理解しました。（研究協力同意に関する文言は、「（A）研究協力に関する同意文言」に記載されています。）<br />
          ・本遺伝子検査サービスの目的、方法、及び想定される検査結果<br />
          ・本遺伝子検査サービスは、全ゲノムシーケンスを用いるものであり、研究目的にのみ行われること。当社から検査申込者にご報告する検査結果やそれに基づくアドバイスは、予防のためのひとつのサービスであって、診断などを目的とした医療行為を含むものではないこと。<br />
          ・検査申込者が本件遺伝子検査サービスを通じて医療機関との連携を申込んだ場合には、当社の提携医療機関に連携されること。その際に、本遺伝子検査サービスの検査結果が、当該医療機関に共有されること。<br />
          ・検査を受けることにより、予想される利益・起こるかもしれない不利益。例えば、疾患性関連の遺伝子変異（劣性（潜性）遺伝病などを含む）が検出された場合、特定の状態を発症するリスクが高いことを意味している可能性があり、検査申込者本人以外にも同じ遺伝子変異がある可能性があること。<br />
          ・検査結果および検査結果報告の一部内容については、提携医療機関との連携後でないとアプリ上で閲覧できないものがあること。また、全ゲノムシーケンスのデータそのものは提供されないこと。<br />
          ・検査結果及び検査結果報告内容を検査申込者へのアドバイス目的のために当社および当社の提携医療機関が閲覧及び利用すること<br />
          ・検査申込者にご報告する検査結果やそれに基づくアドバイスは、予防のためのひとつのサービスであって、診断などを目的とした医療行為を含むものではないこと。<br />
          ・提携医療機関との連携により受けられるオンラインコンサルテーションは、診療行為ではなく、検査結果報告内容に関するものに限られること。<br />
          ・本遺伝子検査サービスが18歳以上を対象としていること（18歳未満の方のお申込みには、親権者同意が必要です。）<br />
          ・医療機関との連携を申込んだ場合には、提携医療機関に情報が提供され、その医療機関と連携されること。なお、本遺伝子検査サービスの一環として提供される医療機関との連携であることを鑑み、この際の医療機関からの連絡は、この同意書の中で検査申込者によって提供された連絡手段によるものとし、合理的と考えられる手段及び範囲内のみでの連絡となること。）<br />
          ・当社が提供するGeneLife会員サービス、アップグレードサービスの適用のため、又は今回もしくは後日研究への協力を行う場合のために本検査の対象検査項目以外の解析を行うこと。<br />
          ・同意書等に記載の事項が、真正なものであること。虚偽の記載があった場合には、当社は本遺伝子検査サービスに関していかなる責任も負わないこと。<br />
          ・本遺伝子検査サービスの利用・提供は日本国内に限ります。(This service is available in and provided to users in Japan only.)<br />
          ・本説明に記載の免責事項。<br />
          ・検査申込者が死亡した場合、本遺伝子検査サービスの一部又は全部の提供が終了する場合があること。<br />
          ・検査申込者が提供する試料・情報等及び遺伝子検査の結果得られる情報・データ等が、本説明に記載の内容に従って取り扱われること。<br />
          ・その他本遺伝子検査サービス及び本研究の内容について、本説明に記載の内容。<br />
          <br />
          <br />
          <br />
          <span className="bold">（A）研究協力に関する同意文言<br />
            ジェネシスヘルスケア株式会社が実施する研究へのご協力についてのお願い及び個人情報の取り扱いに関するお知らせ</span><br />
          <br />
          本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」）では、申込者のだ液の全ゲノム配列解析（WGS）を行います。本遺伝子検査サービスと同時に研究協力に同意いただくことにより、本研究の成果は当社や当社の共同研究先における研究、また、当社の将来的事業を開発するための重要参考資料となることが考えられます。説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご協力いただけるかどうかをご自身でご判断ください。皆様のご理解と研究へのご協力をお願い申し上げます。<br />
          <br />
          ジェネシスヘルスケア株式会社（以下「当社」という）は、検査申込者からの同意を得て、お預かりした試料・情報等（以下に定義する）を「本研究」（以下に定義する）に使用しています。検査申込者からお預かりした個人遺伝情報とアンケートの回答結果（生活習慣や既往歴、家族歴などの情報）をデータマイニングすることで、遺伝子型と疾患リスクや体質との因果関係の解明など、一人ひとりの遺伝的な体質に合わせた疾患予防方法の構築へ貢献できると期待されます。<br />
          <br />
          <br />
          ＜本研究に利用させていただく試料・情報等＞<br />
          当社は、個人遺伝情報とアンケートの回答結果（生活習慣や既往歴、家族歴等の情報）を用いて遺伝子型と疾患発症リスクや体質との因果関係の解明、日本人の様々な疾患リスクや体質を予測するための解析技術や予測モデル、予防方法（生活習慣改善のためのアドバイスなど）の開発や、将来的な疾患予防及び健康の維持・増進のための取組みを実施いたします。本研究にご同意いただける場合には、検査申込者の検査試料、検査結果及び年齢、性別などの属性情報、身体的特徴及び生活習慣、既往歴、家族歴等を含むアンケートのご回答内容、住所・ご連絡先など（以下、これらを合わせて「試料・情報等」といいます。）を本研究のために利用させていただきます。本研究に利用する情報等は追加・変更の可能性があります。<br />
          ＜本研究＞<br />
          本検査を通じて検査申込者よりご提供いただいた試料・情報等（本検査の結果を解析・加工して得られる情報・データ等を含む）は、例えば以下の研究を行うために用います。<br />
          ・遺伝的な疾患リスクや体質に関する研究並びに健康にまつわるビッグデータ（健康・美容・祖先など）の構築及びそれを用いた健康の維持・増進、疾患予防を目的とした研究<br />
          ・創薬（製薬）、医療機器の開発・改良を目的とした研究<br />
          ・消費行動の分析、商品・サービスの開発、健康リスクに関する研究<br />
          ＜本研究の方法＞<br />
          当社は、本検査を通じて検査申込者よりご提供いただいた試料・情報等を用いて、本検査において利用する個人遺伝情報の範囲よりも広範な情報を利用した研究を実施します。試料・情報等を利用して行われる個々の研究については倫理審査委員会の承認を得た上で実施いたします。また、本研究の成果は学会や学術雑誌などでの発表のほか、当社WEBサイト等を通じて公開されます。公開される研究の成果は統計的なデータであり、特定の個人を識別できる情報は含みません。<br />
          ＜本研究の期間＞<br />
          本研究の期間は当社が提供するサービス終了までを予定していますが、変更する可能性もあります。変更する場合は、当社倫理審査委員会の承認及び当社遺伝学研究所の責任者による許可を得た上で、当社WEBサイトにおいて開示します。<br />
          ＜試料・情報等の取扱い＞<br />
          試料・情報等は、ID番号により匿名化して個人遺伝情報の正確性の確保、安全管理措置、従業者の監督及び委託先の監督を行って管理されます。また、検査試料を保存する場合は当社遺伝学研究所または当社が提携している検査受託会社において適切に保存いたしますが、本研究及び倫理審査委員会の承認を得て実施する研究が終了した後に、当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。<br />
          ＜同意の撤回＞<br />
          お申し出いただければいつでも本研究目的での利用に関する同意を撤回できます。同意の撤回を受付けた後、以後の本研究における利用を停止します。但し、既に研究に利用され、研究結果が公表されている部分について利用を停止することはできません。<br />
          ＜研究結果の開示＞<br />
          本研究の結果については、検査申込者に対し、開示や報告は致しません。<br />
          ＜知的財産について＞<br />
          本研究の結果として、特許権等の権利及びそれに基づく経済的利益が生じた場合の当該権利及び利益は、当社、共同研究機関又は本研究及び共同研究の研究者に帰属します。<br />
          ＜将来的に他の研究（ヒトゲノム・遺伝子解析研究を含む）に利用される可能性＞<br />
          検査申込者にご提供いただく試料・情報等は将来的に他の研究機関に提供し、更なる研究のために利用される可能性があります。この場合、当社倫理審査委員会及び他の研究機関の倫理審査委員会の承認を得た上で研究を実施します。<br />
          ＜共同研究＞<br />
          当社は、他の研究機関や企業と共同で研究を行うことがあります。その際には、当社及び共同研究を行う共同研究機関もしくは企業の倫理審査委員会の承認を得た上でその旨を当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）開示します。当社は試料・情報等をID番号により匿名化して、他の研究機関や企業に提供することがあります。将来的に、かかる措置・加工を行わずに試料・情報等を共有・提供する場合も、利用目的その他詳細について当社所定の方法により（文書もしくは当社WEBサイトもしくは当社アプリケーション等）ご案内の上、検査申込者の同意をいただいた上で行います。<br />
          ＜第三者提供＞<br />
          当社は、倫理審査委員会において承認された場合に限り、当社が取得した試料・情報等を研究用データベースとして運用するなど、第三者が実施する研究に対して本研究の成果及び試料・情報等を提供する場合があります。この場合、当該第三者が実施する研究の詳細を、当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）よりご案内の上、試料・情報等を第三者提供することについて検査申込者の同意をいただいた上で第三者に提供します。当社は、試料・情報等を特定の個人を識別できないように加工して、個人情報を復元しても特定の個人を再識別できないようにした上で、第三者に提供する場合があります。<br />
          本件同意により、当社の共同研究先との現在の、もしくは将来行われる個別の研究において、特定の個人を識別できる形で試料・情報等を当該当社の共同研究先に対して提供する場合があります。<br />
          ＜個人情報の利用目的について＞<br />
          上記のほか、当社は、検査申込者に対して、将来的に、検査申込者の同意に基づき、本検査の結果に関連して当社または他の研究機関・企業等のサービス・商品・治験等に関する情報の紹介を行う目的で、個人情報を含む試料・情報等を利用させて頂く場合があります。なお、同様の目的で、ご連絡先等の個人情報を第三者に提供する場合は、当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）、当該第三者研究機関・企業等及び提供目的等の詳細をご案内の上、個人情報を提供することについて検査申込者の同意をいただいた上で行います。<br />
          ＜本研究の責任機関について＞<br />
          ジェネシスヘルスケア株式会社　<br />
          東京都渋谷区恵比寿四丁目20番3号　恵比寿ガーデンプレイスタワー26階<br />
          ＜本研究に関するお問合せ＞<br />
          電話：0120-863-438　平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          <br />
          <br />
          <br />
          <span className="bold">（B）検査申込に関する同意文言<br />
            ジェネシスヘルスケア株式会社による遺伝子検査サービスの提供に関する個人情報の取り扱いに関する表示</span><br />
          <br />
          ジェネシスヘルスケア株式会社（以下「当社」という）は、検査申込者からの同意を得て、お預かりした試料・情報等をもとに、当社が遺伝子について遺伝子検査サービスを行い、検査申込者に検査結果を報告します。遺伝子検査サービスの提供に際して、個人情報を扱う組織、利用目的等に関する表示は以下の通りです。<br />
          <br />
          ＜組織の名称＞<br />
          ジェネシスヘルスケア株式会社<br />
          東京都渋谷区恵比寿四丁目20番3号 恵比寿ガーデンプレイスタワー26階<br />
          電話：03-5422-8506<br />
          代表取締役　David Baran<br />
          ＜個人情報保護管理者の所属及び連絡先（請求等に応じる場合の問合せ窓口）＞<br />
          個人情報に関する窓口<br />
          ジェネシスヘルスケア株式会社<br />
          電話：03-5422-8506　平日10:00～17:00（土日祝を除く）<br />
          東京都渋谷区恵比寿四丁目20番3号恵比寿ガーデンプレイスタワー26階<br />
          ＜利用目的＞<br />
          本検査は、検査申込者が検体（だ液等）を採取し、検査試料として当社に送付することで、人類遺伝学、多因子疾患の発症リスク、アルコール・カフェイン等の嗜好性物質に対する反応性に関連する遺伝子について遺伝子検査サービスを行い、健康や美容等のサポートに役立つアドバイスとともに、検査申込者に検査結果を報告するものです。<br />
          ＜個人情報の第三者提供あるいは個人情報の取扱いの委託を行うことが予定される場合＞<br />
          本検査は、当社遺伝学研究所もしくは当社が提携している検査受託会社に委託して解析しています。この際、特定の個人を識別できないように検査試料を匿名化（記号化）して取扱います。匿名化した情報で個人情報に該当する場合は、個人情報保護法に基づいて情報の安全管理が図れるよう適切に監督します。<br />
          ＜個人情報の提供が任意であること及び当該情報が提供されない場合に生ずる結果＞<br />
          本検査は、検査申込者が任意に検査試料（だ液等）を採取し、当社に送付することで、当社が遺伝子について遺伝子検査サービスを行い、検査申込者に検査結果を報告するものです。検査試料と署名のある検査申込同意書の両方の受領確認が完了しない場合には、遺伝子の解析及び検査結果の報告ができません。<br />
          ＜認定個人情報保護団体の苦情解決の申出先＞<br />
          当社は、認定個人情報保護団体である一般社団法人遺伝情報取扱協会の対象事業者です。一般社団法人遺伝情報取扱協会は対象事業者の個人情報の取扱いに関する苦情および相談を受付けています。<br />
          一般社団法人遺伝情報取扱協会<br />
          電話番号03-6261-7697　FAX：03-5226-1089<br />
          お問い合わせフォーム　https://aogi.jp/<br />
          ＜提供いただいた個人情報の開示等の請求について＞<br />
          当社に対して個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止、第三者への提供の停止、消去）の請求することができます。<br />
          ご要望がある場合は当社問合せ窓口にご連絡ください。その際、当社はご本人を確認させていただいたうえで、合理的な期間内に対応いたします。<br />
          （上記表示は、一般財団法人医療情報システム開発センター『保健医療福祉分野のプライバシーマーク認定指針（第4.1版）』に準拠しています。<br />
          <br />
          <br />
          <br />
          <span className="bold">遺伝子検査サービス申込同意書付属説明書<br />
            遺伝子検査サービスの利用にあたって</span><br />
          （2022年7月1日作成/2024年８月26日改訂）<br />
          <br />
          <br />
          <br />
          ■遺伝子検査サービスを提供する目的等<br />
          ジェネシスヘルスケア株式会社（以下「当社」という）が検査申込者に本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」もしくは、「本検査サービス」という）を提供する主な目的は、健康の維持・増進に関する情報のひとつとしてご活用いただくためです。本遺伝子検査サービスでは、申込者のだ液の全ゲノム配列解析（WGS）を行います。この説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご利用いただきますよう、ご協力をお願い申し上げます。<br />
          <br />
          本検査は、診断に代わるものではありませんが、個人の遺伝学的情報（※1）を明らかにする遺伝子検査サービスであり、①特定の病気の疾患リスク、②体質、③その他当社の定める検査項目に関連する遺伝子について統計に基づいた解析を行います。公になっている論文等に加え、当社の遺伝学の研究者や栄養学の資格を持つ専門家等が監修を行い、遺伝的要因と環境要因の関係を考察して得た、健康や美容等のサポートに役立つアドバイスや結果にまつわる情報をサービスの一環として提供します。<br />
          また、遺伝学の発展を推進するための研究も同時に行っており、これは遺伝子検査サービスの有効性を広く知らしめることを目指した取組みです。<br />
          ※1　遺伝子解析研究により明らかにされる情報<br />
          <br />
          ■科学的根拠について<br />
          当社では遺伝子検査サービス分野におけるリーディングカンパニーとして、科学的根拠の妥当性を評価するにあたり、あらゆる角度からベストプラクティスを試みています。<br />
          検査結果については、現時点において最も適切であると判断した学術論文の内容を反映させています。当社では、当社の検査機関であるジェネシス遺伝学研究所（以下「当社遺伝学研究所」という）が、次の項目に重点を置き、学術論文の科学的妥当性を評価しています。<br />
          1.対象集団：主に東アジア人もしくは日本人で科学的根拠がある<br />
          2.論文名・著者・発行年<br />
          3.参考としている論文の評価<br />
          但し、遺伝的要因と環境要因の関係については現在も研究が進められているため、完全なものではありません。もし、将来的に新しい研究成果が得られた場合、検査結果は関連する科学的知見の更新に基づいて適宜変更される場合がありますので、予めご了承ください。<br />
          また、遺伝子解析には最新の解析技術を使用していますが、検査には技術的な限界があり、検査結果から得られる情報が限定的なものであることをご理解の上、ご活用ください。<br />
          本検査は診断などを目的とした医療行為に該当しないものであり、検査結果は診断ではなく、医師の診断内容や処方箋を置き換えるものではありません。医師の診療を受けている、もしくは医師の診療を受けた場合には、医師の指導を優先してください。また、遺伝子解析の結果のみをサービスとして提供しており、医療情報等は含みませんので予めご了承ください。<br />
          <br />
          ■個人遺伝情報及び個人情報の保管・管理について<br />
          当社はお客様の個人遺伝情報及び個人情報の保管にも万全の体制を導入しています。 日本の法律上、個人遺伝情報は個人情報保護法に基づいて管理を行っています。当社は個人遺伝情報取扱事業者であり、個人遺伝情報及び個人情報の取扱いは、以下の法令等に遵守しており、個人遺伝情報の正確性の確保、安全管理措置、従業者の監督及び委託先の監督を行っています。尚、お客様の解析データは結果通知時から1年間保管しますので、期間中はいつでも結果が閲覧できます。ただし、状況の変化によって変更することがあります。なお、GeneLife会員専用サブスクリプションサービス（GeneLife CONNECT）にお申込みいただいたお客様はGeneLife CONNECTの規程が適用されます。検査後にお申出いただければ、同意の撤回、個人遺伝情報及び個人情報のデータ削除も承っております。<br />
          •個人情報の保護に関する法律<br />
          •人を対象とする生命科学・医学系研究に関する倫理指針<br />
          •個人情報の保護に関する法律についてのガイドライン(通則編、外国にある第三者への提供編、第三者提供時の確認・記録義務編、匿名加工情報編)<br />
          •経済産業分野のうち個人遺伝情報を用いた事業分野における個人情報保護ガイドライン(個人遺伝情報保護ガイドライン) （※2）<br />
          ※2　サービスのうち、経済産業分野を対象とする部分に関して。<br />
          <br />
          ■遺伝子検査サービスの概要<br />
          1.本検査サービスは、検査申込者がだ液を採取し、検査試料として当社に送付することで、人類遺伝学（※3）、多因子疾患の発症リスク（※4）、アルコール・カフェイン等の嗜好性物質に対する反応性（※5）、性格、祖先のルーツなど、検査サービスごとに定められた検査項目に関連する遺伝子について遺伝子検査サービスを行い、健康や美容等のサポートに役立つアドバイスや結果にまつわる情報とともに、検査申込者に検査結果を報告するものです。<br />
          2.解析方法は、全ゲノム解析（WGS: whole genome sequencing）法を用いています。<br />
          3.検査結果の受領方法は、当社の各商品・サービスの標準規格となっており、検査申込者の任意で選べるものではありません。定期的な料金支払を条件としている商品・サービスをご利用されている場合、料金支払が確認できない場合には商品・サービスの提供が中止される場合があります。<br />
          4.検査試料と署名のある検査申込同意書の両方の受領確認が完了しない場合には、遺伝子の解析及び検査結果の報告ができません。受領確認ができなかったことに起因する検査試料の劣化等に関する損害については、当社では責任を負いかねます。また、検査申込者の過失によって検査に必要な部材を紛失した場合、その部材にかかる所定の費用をお支払いいただいた場合のみ、検査に必要な部材をお送りします。<br />
          5.本検査サービスのうち、ClinVar（Clinical Variation）やACMG（American College of Molecular Genetics）などの希少疾患等は人種の影響をほぼ受けないと考えられています。しかし、肥満や肌質等の体質は東アジア人を対象としたものであり、検査結果が全ての人種の方に対して必ずしも該当するとは限りませんので、予めご了承ください。<br />
          6.本検査サービスは、18歳以上の年齢の方を対象としており、18歳未満の方のお申込みには親権者同意が必要です。予めご了承ください。<br />
          7.通常、本検査サービスは検査試料が当社に到着してから約6～8週間後に検査結果を報告していますが、年末年始やゴールデンウィーク等の長期の休日を挟んだ場合や、甚大なる自然災害等の発生した場合は、報告までにさらに日数がかかる場合があります。また、再検査が必要となった場合、あるいは解析状況等によっても、報告までにさらに日数がかかる場合があります。<br />
          8.本検査サービスは、当社遺伝学研究所もしくは当社が提携している検査受託会社に委託して解析しています。この際、特定の個人を識別できないように検査試料を匿名化（記号化）して取扱います。匿名化した情報で個人情報に該当する場合は、個人情報保護法に基づいて情報の安全管理が図れるよう適切に監督しています。また、遺伝データの保存は国内において行っています。<br />
          9.本検査サービスは研究目的の検査です。遺伝子解析に用いる技術は最新のものを採用していますが、検査結果の正確性、完全性を保証することはいたしかねます。また、採取したDNAの品質や遺伝子配列の特徴により、一部の検査結果が得られない恐れがあることが分かっています。事前にどの遺伝子の結果が出ないか予測することは不可能であることを承知の上、お申し込みください。<br />
          10.検査試料及び抽出したDNAを返却することはありません。検査試料は遺伝子の解析に必要な期間保存しますが、検査結果報告後に当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。抽出したDNAは、検査申込者と当社との契約に基づいて、当社にて適切な方法で保管します。検査申込者と当社との契約が解約された場合は、当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。<br />
          11.本検査サービスは、法医学鑑定（※6）、劣性（潜性）遺伝、常染色体優性（顕性）遺伝の診断目的の遺伝子検査サービスではありません。<br />
          12.血縁者は同じ遺伝子を持っている可能性があり、検査申込者のみでなく本検査サービスを受けていない血縁者の検査結果を想定できる場合がありますが、必ずしも一致するものではありません。<br />
          13.検査結果を知ることにより、精神的な負担となるような場合があることも想定されます。本検査サービスを十分な理解の上で、検査申込者の責任において検査申込みを行ってください。<br />
          14.検査結果が第三者に知られるところとなった場合、検査申込者に対する差別等の社会的不利益がもたらされる可能性や予想外の影響が見込まれます。検査結果の開示は、本検査を十分な理解の上で、必ず検査申込者の判断で行ってください。<br />
          15.本検査サービスの検査項目及び遺伝子は、当社WEBサイト（https://www.genelife.jp）をご確認ください。<br />
          ※3　生理学的な特徴に関連した遺伝子を解析するものです。<br />
          ※4　当社が検査申込者に遺伝学的検査を提供する主たる目的は、健康診断等の他の検査と同様にいくつかある健康維持増進に関する情報のひとつとしてご利用いただくことです。遺伝学的検査は個人の遺伝学的情報を明らかにする遺伝学的検査であり、統計に基づいた①特定の病気の発症リスク、②体質、③その他当社の定める検査項目に関連する当社WEBサイト記載の遺伝子について解析を行います。公になっている論文等に加え、当社の遺伝学、栄養学等の資格及び提携医療機関の資格を有する専門家が監修を行い、遺伝的要因と環境要因の関係を考察して得た健康や美容等のサポートに役立つアドバイスをサービスの一環として提供しています。遺伝性が高い疾患の場合、ClinVar（Clinical Variation）、ACMG（American College of Molecular Genetics）の疾患スクリーニング/専門家パネルの情報が参考とされています。但し、この検査は診断・診療ではありませんので確定情報にはなりません。肥満・肌・体質・祖先など低侵襲性の約360項目はアプリで結果が確認できますが、ClinVar、ACMGなどの残りの6,200程度の侵襲性が高い疾患を含むパネルは、アプリを通じて提携医療従事者とのオンラインコンサルテーションを経た後でないとご覧になれません。また、遺伝的な発症の予測リスクは、検査申込者と似た症状を持つ膨大な統計データから算出した値であり、検査申込者が同じ疾患を発症することを断定するものではありません。<br />
          ※5　アルコール・カフェイン等の嗜好性物質に対する反応性には著しい個体差が認められており、この傾向性を予測するために、関連する遺伝子を解析するものです。<br />
          ※6　DNA鑑定、親子・血縁鑑定等<br />
          <br />
          ■情報の取扱いについて<br />
          1.当社における個人遺伝情報及び個人情報（※7）の取扱いは、個人情報保護法、経済産業省が定めているガイドライン（※2）及び一般社団法人遺伝情報取扱協会の自主基準（※2）を遵守しています。<br />
          2.個人遺伝情報及び個人情報は、特定の個人を識別できないように加工して、当該情報を復元して特定の個人を再識別できないようにしたものを分析データとして集積した上で、社会的な必要性等を鑑みて統計として開示されることがあります。<br />
          3.匿名化した情報を精度管理及び品質保証、またはこれらに付随する研究目的等のために利用する場合があります。<br />
          4.検査サービス申込同意書に記入された個人情報は、当社プライバシーポリシーに基づき細心の注意を払って保管し、本人確認や検査申込みの内容確認のために利用します。プライバシーポリシーの詳細は、当社WEBサイト（https://www.genelife.jp）をご確認ください。<br />
          5.当社は、原則として本人の同意がない限り個人遺伝情報及び個人情報を第三者に提供することはありませんが法律に従って開示せざるを得ない場合は、当社の判断により個人遺伝情報及び個人情報を開示する場合があります。<br />
          6.当社は、個人遺伝情報取扱の倫理審査の機能を有する個人遺伝情報取扱審査委員会を設置しており、当社が個人遺伝情報取扱審査委員会に個人遺伝情報取扱の倫理審査の開始を要請した場合、個人遺伝情報取扱審査委員会は公正かつ中立的に当該事業実施の適否の審査を行います。<br />
          7.検査結果に関しては、＜サービス全般及び検査結果に関する窓口＞記載のお問合せ窓口までご連絡ください。尚、検査結果に基づくご質問等、個人遺伝情報に関わる事項については、検査申込者であるご本人からのお問合せに対してのみ回答します。本人確認として、氏名、生年月日、住所、電話番号等を確認させていただきますので、予めご了承ください。また、お問合せの内容によっては、本人確認のためにパスポートや運転免許証の写し等の資料を提出していただく場合がございますので、事前にご用意ください。<br />
          8.検査申込同意書に記載された後、個人情報の訂正や検査同意の撤回を依頼される場合は、＜個人情報に関する窓口＞記載のお問合せ窓口までご連絡ください。その際、検査試料及び検査結果は特定の個人を識別できない状態で廃棄しますが、既にお支払いいただいた検査にかかる部材一式及び検査費用の代金は返金できません。<br />
          9.当社のデータベースで保管されている個人遺伝情報及び個人情報の開示、利用停止、削除をご希望される場合には、＜個人情報に関する窓口＞記載のお問合せ窓口までご連絡ください。但し、個人遺伝情報及び個人情報（検査結果データを含む）が削除された後は、当社WEBサイト上で検査結果の閲覧ができなくなりますので、予めご了承ください。<br />
          10.ご送付いただいた検査試料の被験者の氏名と、検査申込みにかかる記入もしくは登録及び検査申込同意書の氏名が同一だった場合、ご本人の意思により本検査を申し込んだことと見なします。ご本人以外の方が氏名等を偽って使用した場合でも、当社では一切責任を負いかねます。<br />
          ※7　検査申込者が記入もしくは登録した検査申込みにかかる内容（体型や病歴に関するデータを含む）や検査結果等において特定の個人を識別することができるもの<br />
          <br />
          ■インターネット・セキュリティおよび動作推奨環境について<br />
          最新の動作推奨環境およびセキュリティに関しましては、当社WEBサイト（https://www.genelife.jp）をご参照ください。<br />
          <br />
          ■検体試料の返送方法等について<br />
          検査試料の返送は当社指定の方式にてご返送いただきます。ただし、当該返送において遅延、検査試料の劣化、誤配送が発生しないことを当社が保証するものではありません。<br />
          <br />
          ■検査及び検査技術について<br />
          本検査サービスで用いている遺伝子解析機器はIllumina社製のNovaSeq 6000、NovaSeqX PlusもしくはMGI社製のDNBSEQ-T7です。全ゲノム解析において、本機器では30X（カバレッジ）が推奨されており、本プロトコルを当社は厳守いたします。全ゲノム解析では高い品質かつ一定量のDNAを必要としています。試料から解析に必要なDNAが抽出できず、基準を満たす検査が実施できなかった場合でも、再検査は行いません。したがって、だ液の採取においては取り扱い説明をよくお読みいただき、手順に従って採取いただきますようお願いいたします。<br />
          1.結果的に全ての解析結果が得られなかった場合でも、検査申込者から試料が当社遺伝学研究所に届いた時点で、既にお支払いいただいた検査にかかる部材一式及び検査費用の代金は返金できません。<br />
          2.本検査には技術的な限界があり、検査結果から得られる情報が限定的なものであることをご理解の上、お申し込みください。検査結果の正確性、完全性を証明する義務を負うことはいたしかねます。<br />
          <br />
          ■反社会的勢力に係る表明保証<br />
          本検査サービスの利用者は、自らが、集団的又は常習的に違法行為（犯罪行為を含むが、これに限定されない）を行い又はこれを助長するおそれがある団体（以下、「反社会的勢力」という）に該当せず、また、反社会的勢力又はその構成員との間に何らの関係もなく、資金提供その他方法の如何を問わず、これらの者の維持、運営に協力又は関与していないことを表明および保証します。なお、以上について重要な違反事実が判明した場合には、当社は検査サービスを実施しない、もしくは何ら予告なく取りやめることができることとします。<br />
          <br />
          ■免責事項<br />
          1.検査試料の品質や検査技術の限界により、100％正確な検査結果が得られない可能性があります。遺伝子検査サービスには一定の限界があることをご理解ください。<br />
          2.当社が指示した方法に従わずに検査試料の採取を行ったことに起因する検査結果の誤判定や事故、その他の不具合について、一切の責任を負いかねます。<br />
          3.当社が指示した方法に従わずに遺伝子検査サービスキットの部材の誤使用（誤飲等を含む）したことにかかる賠償には応じられません。<br />
          4.口腔内にカフェイン、ポリフェノールなどが付着していたり、疾患（歯周病など）がある場合は、検査を阻害する物質が検査試料に混入するため、繰り返し検査を行っても検査結果が得られないこともありますので、予めご了承ください。<br />
          5.本検査サービスのID及びパスワードは、ご本人が登録の上で厳重に管理していただくようお願いいたします。万が一他者と入れ違いで登録された場合について、当社は一切の責任を負いかねます。<br />
          6.当社が遺伝子の解析過程における事故や不具合を認めた場合を除き、本検査サービスにかかる返金はできません。また、いかなる理由においても、本検査を購入されたお客様にお支払いいただいた遺伝子検査キット代金以上の賠償には応じられません。<br />
          7.検査結果は、健康の維持・増進や生活の充実に関する情報のひとつとして活用していただくことを目的として提供しており、当社の情報提供の目的範囲を超える法的活動、商業活動、営業活動、医療活動等への再利用については、当社は責任を負いかねます。<br />
          8.検査申込者から受領した検査試料や遺伝子検査サービス申込同意書、検査結果の取扱いには細心の注意を払っていますが、次の事由による検査試料や検査申込同意書、検査結果の滅失や、検査申込者からの検査試料返送時における損害等については、当社は損害賠償の責任を負いません。<br />
          ①地震、津波、高潮、大水、暴風雨、地すべり、山崩れ、疫病等その他の天災<br />
          ②ストライキ、サボタージュ<br />
          ③戦争、テロまたは社会的騒擾その他の事変等社会的争乱<br />
          ④核燃料物質に基づく放射性、爆発性その他の有害な特性による事故またはそれに基づく社会的混乱<br />
          ⑤不可抗力による火災<br />
          ⑥予見できない異常な交通障害<br />
          ⑦法令または公権力発動による運送の差止め、開封、没収、差押えまたは第三者への引渡し<br />
          ⑧検査試料返送時における配送会社による故意または過失に起因する検査試料や検査申込同意書、検査結果の遅延・紛失等の事故<br />
          ⑨検査申込者が検査試料の返送用封筒に記載する外装表示の記載過誤、検査申込者の故意または過失に起因する検査試料返送時の事故<br />
          <br />
          ■返品・返金<br />
          未開封の状態に限り、商品到着後8日以内であれば返品・返金に対応いたします。開封後の返品・返金につきましてはお受けすることができません。予めご了承ください。商品に瑕疵がある場合は、返品していただき瑕疵が確認された場合のみ、本検査を購入されたお客様にお支払いいただいた遺伝子検査キット代金の全額返金に応じます。<br />
          <br />
          ■使用期限<br />
          本商品の使用期限はパッケージに記載されている期日となります。使用期限内に検査試料を採取してください。また、試料採取後は採取当日にご返送ください。使用期限内であってもお早めにご使用いただくことをおすすめします。使用期限を過ぎた検査はお受けすることができませんのでご注意ください。使用期限を過ぎたことによる返金・返品はいたしかねますので予めご了承ください。<br />
          <br />
          ■遺伝子検査サービス申込同意書及びプライバシーポリシーの改定について<br />
          遺伝子検査サービス申込同意書の取扱いは、2022年7月1日以降に適用するものとします。当社では、検査申込者の個人情報の保護を図るために、また法令その他の規範の変更に対応するために、遺伝子検査サービス申込同意書、プライバシーポリシーを改定することがあります。特に重要な変更につきましては、当社WEBサイトにおいてお知らせします。<br />
          <br />
          ■準処法・管轄<br />
          本検査は、日本国の法令に準拠し、それに従って解釈するものとし、また、本検査に関する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。<br />
          <br />
          ■個人遺伝情報取扱審査委員会による審査<br />
          当社は、以下の法令等に基づき、ジェネシスヘルスケア株式会社個人遺伝情報取扱審査委員会を設置しております。<br />
          •個人情報の保護に関する法律<br />
          •人を対象とする生命科学・医学系研究に関する倫理指針<br />
          •個人情報の保護に関する法律についてのガイドライン(通則編、外国にある第三者への提供編、第三者提供時の確認・記録義務編、匿名加工情報編)<br />
          •経済産業分野のうち個人遺伝情報を用いた事業分野における個人情報保護ガイドライン(個人遺伝情報保護ガイドライン)<br />
          当該委員会は、当社から独立した立場に立って、科学的、倫理的、法的、社会的、技術的観点から本サービス実施の適否等について審査を行い、適正な事業実施のために意見します。<br />
          <br />
          ■検査結果に関わるコンサルテーションについて<br />
          当社の提供する遺伝子検査サービスに関するご相談をお受けしています。コンサルテーションは、当社提携クリニックの医師及び当社の遺伝学の研究者や専門家等により実施される体制を整備しています。以下よりご連絡ください。<br />
          ＜お問合せ窓口＞<br />
          電話：0120-863-438<br />
          平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          <br />
          ■お問合せ<br />
          ＜サービス全般及び検査結果に関する窓口＞<br />
          電話：0120-863-438  平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          メールでの問合せ先：infogene@genelife.jp<br />
          <br />
          ＜個人情報に関する窓口＞<br />
          電話：03-5422-8506　平日10:00～17:00（土日祝を除く）<br />
          ジェネシスヘルスケア株式会社　<br />
          〒150-6026 東京都渋谷区恵比寿四丁目20番3号 恵比寿ガーデンプレイスタワー 26階<br />
          <br /><br /><br /><br /><br />
          <span className="bold">私は本検査を受けないという選択が可能であることを理解した上で、自らの意思で、採取した検査試料を送付し、検査を行うことに同意します。</span><br />
        </div>
      </div>
    </>
  );

  const wgsConnectConsent = (
    <>
      <div className="fieldwrap">
        <h2 className="fieldtitle">検査IDの入力</h2>
        <div className="coutionbox">
          よくお読みになり、内容をご理解されたうえで同意してください。本検査サービスは、18歳以上の年齢の方を対象としており、当社の個人遺伝情報取扱審査委員会が定める倫理的、社会的な観点から18歳未満の方の検査は行えませんので、予めご了承ください。
        </div>
      </div>
      <div className="fieldwrap">
        <div className="consenttext container">
          <span className="bold">遺伝子検査サービス申込同意書 兼 研究協力同意書</span><br />
          <br />
          ジェネシスヘルスケア株式会社　<br />
          遺伝学検査室　御中<br />
          医療法人社団創世会 臨床検査科恵比寿(ジェネシスヘルスケア株式会社提携医療法人)御中（※）<br />
          ※他の提携医療機関が追加された場合には、当該提携医療機関も含むものとします。<br />
          <br />
          本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」）では、申込者のだ液の全ゲノムシーケンス（WGS）を行います。全ゲノムシーケンスに関しては、グローバルスタンダードとされている手法を用いますが、まだ発展段階の技術でもあることから、一層の精度・品質管理、技術・判断・評価の向上を行う観点から、この遺伝子検査サービスは、研究目的でのみ提供しております。従いまして、この遺伝子検査サービスは研究同意をいただいた場合にのみ提供しております（研究同意が必須です）。本遺伝子検査サービスと同時に研究協力に同意いただくことにより、本研究の成果は当社や当社の共同研究先における研究、また、当社の将来的事業を開発するための重要参考資料となることが考えられます。説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご協力いただけるかどうかをご自身でご判断ください。皆様のご理解と研究へのご協力をお願い申し上げます。<br />
          <br />
          私は遺伝子検査サービス申込同意書付属説明書＜遺伝子検査サービスの利用にあたって＞の説明及び（A）研究協力に関する同意文言、（B）検査申込に関する同意文言（以下あわせて「本説明」）を読み、「本遺伝子検査サービス」及び本説明に記載の「本研究」について、以下の内容を理解しました。（研究協力同意に関する文言は、「（A）研究協力に関する同意文言」に記載されています。）<br />
          ・本遺伝子検査サービスの目的、方法、及び想定される検査結果<br />
          ・本遺伝子検査サービスは、全ゲノムシーケンスを用いるものであり、研究目的にのみ行われること。当社から検査申込者にご報告する検査結果やそれに基づくアドバイスは、予防のためのひとつのサービスであって、診断などを目的とした医療行為を含むものではないこと。<br />
          ・検査申込者が本件遺伝子検査サービスを通じて医療機関との連携を申込んだ場合には、当社の提携医療機関に連携されること。その際に、本遺伝子検査サービスの検査結果が、当該医療機関に共有されること。<br />
          ・検査を受けることにより、予想される利益・起こるかもしれない不利益。例えば、疾患性関連の遺伝子変異（劣性（潜性）遺伝病などを含む）が検出された場合、特定の状態を発症するリスクが高いことを意味している可能性があり、検査申込者本人以外にも同じ遺伝子変異がある可能性があること。<br />
          ・検査結果および検査結果報告の一部内容については、提携医療機関との連携後でないとアプリ上で閲覧できないものがあること。また、全ゲノムシーケンスのデータそのものは提供されないこと。<br />
          ・検査結果及び検査結果報告内容を検査申込者へのアドバイス目的のために当社および当社の提携医療機関が閲覧及び利用すること<br />
          ・検査申込者にご報告する検査結果やそれに基づくアドバイスは、予防のためのひとつのサービスであって、診断などを目的とした医療行為を含むものではないこと。<br />
          ・提携医療機関との連携により受けられるオンラインコンサルテーションは、診療行為ではなく、検査結果報告内容に関するものに限られること。<br />
          ・本遺伝子検査サービスが18歳以上を対象としていること（18歳未満の方はお申込みできません）<br />
          ・医療機関との連携を申込んだ場合には、提携医療機関に情報が提供され、その医療機関と連携されること。なお、本遺伝子検査サービスの一環として提供される医療機関との連携であることを鑑み、この際の医療機関からの連絡は、この同意書の中で検査申込者によって提供された連絡手段によるものとし、合理的と考えられる手段及び範囲内のみでの連絡となること。）<br />
          ・当社が提供するGeneLife会員サービス、アップグレードサービスの適用のため、又は今回もしくは後日研究への協力を行う場合のために本検査の対象検査項目以外の解析を行うこと。<br />
          ・同意書等に記載の事項が、真正なものであること。虚偽の記載があった場合には、当社は本遺伝子検査サービスに関していかなる責任も負わないこと。<br />
          ・本遺伝子検査サービスの利用・提供は日本国内に限ります。(This service is available in and provided to users in Japan only.)<br />
          ・本説明に記載の免責事項。<br />
          ・検査申込者が死亡した場合、本遺伝子検査サービスの一部又は全部の提供が終了する場合があること。<br />
          ・検査申込者が提供する試料・情報等及び遺伝子検査の結果得られる情報・データ等が、本説明に記載の内容に従って取り扱われること。<br />
          ・その他本遺伝子検査サービス及び本研究の内容について、本説明に記載の内容。<br />
          <br />
          <br />
          <br />
          <span className="bold">（A）研究協力に関する同意文言<br />
            ジェネシスヘルスケア株式会社が実施する研究へのご協力についてのお願い及び個人情報の取り扱いに関するお知らせ</span><br />
          <br />
          本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」）では、申込者のだ液の全ゲノム配列解析（WGS）を行います。本遺伝子検査サービスと同時に研究協力に同意いただくことにより、本研究の成果は当社や当社の共同研究先における研究、また、当社の将来的事業を開発するための重要参考資料となることが考えられます。説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご協力いただけるかどうかをご自身でご判断ください。皆様のご理解と研究へのご協力をお願い申し上げます。<br />
          <br />
          ジェネシスヘルスケア株式会社（以下「当社」という）は、検査申込者からの同意を得て、お預かりした試料・情報等（以下に定義する）を「本研究」（以下に定義する）に使用しています。検査申込者からお預かりした個人遺伝情報とアンケートの回答結果（生活習慣や既往歴、家族歴などの情報）をデータマイニングすることで、遺伝子型と疾患リスクや体質との因果関係の解明など、一人ひとりの遺伝的な体質に合わせた疾患予防方法の構築へ貢献できると期待されます。<br />
          <br />
          <br />
          ＜本研究に利用させていただく試料・情報等＞<br />
          当社は、個人遺伝情報とアンケートの回答結果（生活習慣や既往歴、家族歴等の情報）を用いて遺伝子型と疾患発症リスクや体質との因果関係の解明、日本人の様々な疾患リスクや体質を予測するための解析技術や予測モデル、予防方法（生活習慣改善のためのアドバイスなど）の開発や、将来的な疾患予防及び健康の維持・増進のための取組みを実施いたします。本研究にご同意いただける場合には、検査申込者の検査試料、検査結果及び年齢、性別などの属性情報、身体的特徴及び生活習慣、既往歴、家族歴等を含むアンケートのご回答内容、住所・ご連絡先など（以下、これらを合わせて「試料・情報等」といいます。）を本研究のために利用させていただきます。本研究に利用する情報等は追加・変更の可能性があります。<br />
          ＜本研究＞<br />
          本検査を通じて検査申込者よりご提供いただいた試料・情報等（本検査の結果を解析・加工して得られる情報・データ等を含む）は、例えば以下の研究を行うために用います。<br />
          ・遺伝的な疾患リスクや体質に関する研究並びに健康にまつわるビッグデータ（健康・美容・祖先など）の構築及びそれを用いた健康の維持・増進、疾患予防を目的とした研究<br />
          ・創薬（製薬）、医療機器の開発・改良を目的とした研究<br />
          ・消費行動の分析、商品・サービスの開発、健康リスクに関する研究<br />
          ＜本研究の方法＞<br />
          当社は、本検査を通じて検査申込者よりご提供いただいた試料・情報等を用いて、本検査において利用する個人遺伝情報の範囲よりも広範な情報を利用した研究を実施します。試料・情報等を利用して行われる個々の研究については倫理審査委員会の承認を得た上で実施いたします。また、本研究の成果は学会や学術雑誌などでの発表のほか、当社WEBサイト等を通じて公開されます。公開される研究の成果は統計的なデータであり、特定の個人を識別できる情報は含みません。<br />
          ＜本研究の期間＞<br />
          本研究の期間は当社が提供するサービス終了までを予定していますが、変更する可能性もあります。変更する場合は、当社倫理審査委員会の承認及び当社遺伝学研究所の責任者による許可を得た上で、当社WEBサイトにおいて開示します。<br />
          ＜試料・情報等の取扱い＞<br />
          試料・情報等は、ID番号により匿名化して個人遺伝情報の正確性の確保、安全管理措置、従業者の監督及び委託先の監督を行って管理されます。また、検査試料を保存する場合は当社遺伝学研究所または当社が提携している検査受託会社において適切に保存いたしますが、本研究及び倫理審査委員会の承認を得て実施する研究が終了した後に、当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。<br />
          ＜同意の撤回＞<br />
          お申し出いただければいつでも本研究目的での利用に関する同意を撤回できます。同意の撤回を受付けた後、以後の本研究における利用を停止します。但し、既に研究に利用され、研究結果が公表されている部分について利用を停止することはできません。<br />
          ＜研究結果の開示＞<br />
          本研究の結果については、検査申込者に対し、開示や報告は致しません。<br />
          ＜知的財産について＞<br />
          本研究の結果として、特許権等の権利及びそれに基づく経済的利益が生じた場合の当該権利及び利益は、当社、共同研究機関又は本研究及び共同研究の研究者に帰属します。<br />
          ＜将来的に他の研究（ヒトゲノム・遺伝子解析研究を含む）に利用される可能性＞<br />
          検査申込者にご提供いただく試料・情報等は将来的に他の研究機関に提供し、更なる研究のために利用される可能性があります。この場合、当社倫理審査委員会及び他の研究機関の倫理審査委員会の承認を得た上で研究を実施します。<br />
          ＜共同研究＞<br />
          当社は、他の研究機関や企業と共同で研究を行うことがあります。その際には、当社及び共同研究を行う共同研究機関もしくは企業の倫理審査委員会の承認を得た上でその旨を当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）開示します。当社は試料・情報等をID番号により匿名化して、他の研究機関や企業に提供することがあります。将来的に、かかる措置・加工を行わずに試料・情報等を共有・提供する場合も、利用目的その他詳細について当社所定の方法により（文書もしくは当社WEBサイトもしくは当社アプリケーション等）ご案内の上、検査申込者の同意をいただいた上で行います。<br />
          ＜第三者提供＞<br />
          当社は、倫理審査委員会において承認された場合に限り、当社が取得した試料・情報等を研究用データベースとして運用するなど、第三者が実施する研究に対して本研究の成果及び試料・情報等を提供する場合があります。この場合、当該第三者が実施する研究の詳細を、当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）よりご案内の上、試料・情報等を第三者提供することについて検査申込者の同意をいただいた上で第三者に提供します。当社は、試料・情報等を特定の個人を識別できないように加工して、個人情報を復元しても特定の個人を再識別できないようにした上で、第三者に提供する場合があります。<br />
          本件同意により、当社の共同研究先との現在の、もしくは将来行われる個別の研究において、特定の個人を識別できる形で試料・情報等を当該当社の共同研究先に対して提供する場合があります。<br />
          ＜個人情報の利用目的について＞<br />
          上記のほか、当社は、検査申込者に対して、将来的に、検査申込者の同意に基づき、本検査の結果に関連して当社または他の研究機関・企業等のサービス・商品・治験等に関する情報の紹介を行う目的で、個人情報を含む試料・情報等を利用させて頂く場合があります。なお、同様の目的で、ご連絡先等の個人情報を第三者に提供する場合は、当社所定の方法により（文書、当社WEBサイトもしくは当社アプリケーション等）、当該第三者研究機関・企業等及び提供目的等の詳細をご案内の上、個人情報を提供することについて検査申込者の同意をいただいた上で行います。<br />
          ＜本研究の責任機関について＞<br />
          ジェネシスヘルスケア株式会社　<br />
          東京都渋谷区恵比寿四丁目20番3号　恵比寿ガーデンプレイスタワー26階<br />
          ＜本研究に関するお問合せ＞<br />
          電話：0120-863-438　平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          <br />
          <br />
          <br />
          <span className="bold">（B）検査申込に関する同意文言<br />
            ジェネシスヘルスケア株式会社による遺伝子検査サービスの提供に関する個人情報の取り扱いに関する表示</span><br />
          <br />
          ジェネシスヘルスケア株式会社（以下「当社」という）は、検査申込者からの同意を得て、お預かりした試料・情報等をもとに、当社が遺伝子について遺伝子検査サービスを行い、検査申込者に検査結果を報告します。遺伝子検査サービスの提供に際して、個人情報を扱う組織、利用目的等に関する表示は以下の通りです。<br />
          <br />
          ＜組織の名称＞<br />
          ジェネシスヘルスケア株式会社<br />
          東京都渋谷区恵比寿四丁目20番3号 恵比寿ガーデンプレイスタワー26階<br />
          電話：03-5422-8506<br />
          代表取締役　David Baran<br />
          ＜個人情報保護管理者の所属及び連絡先（請求等に応じる場合の問合せ窓口）＞<br />
          個人情報に関する窓口<br />
          ジェネシスヘルスケア株式会社<br />
          電話：03-5422-8506　平日10:00～17:00（土日祝を除く）<br />
          東京都渋谷区恵比寿四丁目20番3号恵比寿ガーデンプレイスタワー26階<br />
          ＜利用目的＞<br />
          本検査は、検査申込者が検体（だ液等）を採取し、検査試料として当社に送付することで、人類遺伝学、多因子疾患の発症リスク、アルコール・カフェイン等の嗜好性物質に対する反応性に関連する遺伝子について遺伝子検査サービスを行い、健康や美容等のサポートに役立つアドバイスとともに、検査申込者に検査結果を報告するものです。<br />
          ＜個人情報の第三者提供あるいは個人情報の取扱いの委託を行うことが予定される場合＞<br />
          本検査は、当社遺伝学研究所もしくは当社が提携している検査受託会社に委託して解析しています。この際、特定の個人を識別できないように検査試料を匿名化（記号化）して取扱います。匿名化した情報で個人情報に該当する場合は、個人情報保護法に基づいて情報の安全管理が図れるよう適切に監督します。<br />
          ＜個人情報の提供が任意であること及び当該情報が提供されない場合に生ずる結果＞<br />
          本検査は、検査申込者が任意に検査試料（だ液等）を採取し、当社に送付することで、当社が遺伝子について遺伝子検査サービスを行い、検査申込者に検査結果を報告するものです。検査試料と署名のある検査申込同意書の両方の受領確認が完了しない場合には、遺伝子の解析及び検査結果の報告ができません。<br />
          ＜認定個人情報保護団体の苦情解決の申出先＞<br />
          当社は、認定個人情報保護団体である一般社団法人遺伝情報取扱協会の対象事業者です。一般社団法人遺伝情報取扱協会は対象事業者の個人情報の取扱いに関する苦情および相談を受付けています。<br />
          一般社団法人遺伝情報取扱協会<br />
          電話番号03-6261-7697　FAX：03-5226-1089<br />
          お問い合わせフォーム　https://aogi.jp/<br />
          ＜提供いただいた個人情報の開示等の請求について＞<br />
          当社に対して個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止、第三者への提供の停止、消去）の請求することができます。<br />
          ご要望がある場合は当社問合せ窓口にご連絡ください。その際、当社はご本人を確認させていただいたうえで、合理的な期間内に対応いたします。<br />
          （上記表示は、一般財団法人医療情報システム開発センター『保健医療福祉分野のプライバシーマーク認定指針（第4.1版）』に準拠しています。<br />
          <br />
          <br />
          <br />
          <span className="bold">遺伝子検査サービス申込同意書付属説明書<br />
            遺伝子検査サービスの利用にあたって</span><br />
          （2022年7月1日作成/2024年9月17日改訂）<br />
          <br />
          <br />
          <br />
          ■遺伝子検査サービスを提供する目的等<br />
          ジェネシスヘルスケア株式会社（以下「当社」という）が検査申込者に本遺伝子検査サービス（GeneLife WGSサービス。以下、「遺伝子検査サービス」もしくは、「本検査サービス」という）を提供する主な目的は、健康の維持・増進に関する情報のひとつとしてご活用いただくためです。本遺伝子検査サービスでは、申込者のだ液の全ゲノム配列解析（WGS）を行います。この説明書をよくお読みになり、皆さまに同意していただく内容（全ゲノム配列解析（WGS）に伴うリスクを含む）をよくご理解された上で、ご利用いただきますよう、ご協力をお願い申し上げます。<br />
          <br />
          本検査は、診断に代わるものではありませんが、個人の遺伝学的情報（※1）を明らかにする遺伝子検査サービスであり、①特定の病気の疾患リスク、②体質、③その他当社の定める検査項目に関連する遺伝子について統計に基づいた解析を行います。公になっている論文等に加え、当社の遺伝学の研究者や栄養学の資格を持つ専門家等が監修を行い、遺伝的要因と環境要因の関係を考察して得た、健康や美容等のサポートに役立つアドバイスや結果にまつわる情報をサービスの一環として提供します。<br />
          また、遺伝学の発展を推進するための研究も同時に行っており、これは遺伝子検査サービスの有効性を広く知らしめることを目指した取組みです。<br />
          ※1　遺伝子解析研究により明らかにされる情報<br />
          <br />
          ■科学的根拠について<br />
          当社では遺伝子検査サービス分野におけるリーディングカンパニーとして、科学的根拠の妥当性を評価するにあたり、あらゆる角度からベストプラクティスを試みています。<br />
          検査結果については、現時点において最も適切であると判断した学術論文の内容を反映させています。当社では、当社の検査機関であるジェネシス遺伝学研究所（以下「当社遺伝学研究所」という）が、次の項目に重点を置き、学術論文の科学的妥当性を評価しています。<br />
          1.対象集団：主に東アジア人もしくは日本人で科学的根拠がある<br />
          2.論文名・著者・発行年<br />
          3.参考としている論文の評価<br />
          但し、遺伝的要因と環境要因の関係については現在も研究が進められているため、完全なものではありません。もし、将来的に新しい研究成果が得られた場合、検査結果は関連する科学的知見の更新に基づいて適宜変更される場合がありますので、予めご了承ください。<br />
          また、遺伝子解析には最新の解析技術を使用していますが、検査には技術的な限界があり、検査結果から得られる情報が限定的なものであることをご理解の上、ご活用ください。<br />
          本検査は診断などを目的とした医療行為に該当しないものであり、検査結果は診断ではなく、医師の診断内容や処方箋を置き換えるものではありません。医師の診療を受けている、もしくは医師の診療を受けた場合には、医師の指導を優先してください。また、遺伝子解析の結果のみをサービスとして提供しており、医療情報等は含みませんので予めご了承ください。<br />
          <br />
          ■個人遺伝情報及び個人情報の保管・管理について<br />
          当社はお客様の個人遺伝情報及び個人情報の保管にも万全の体制を導入しています。 日本の法律上、個人遺伝情報は個人情報保護法に基づいて管理を行っています。当社は個人遺伝情報取扱事業者であり、個人遺伝情報及び個人情報の取扱いは、以下の法令等に遵守しており、個人遺伝情報の正確性の確保、安全管理措置、従業者の監督及び委託先の監督を行っています。尚、お客様の解析データは結果通知時から1年間保管しますので、期間中はいつでも結果が閲覧できます。ただし、状況の変化によって変更することがあります。なお、GeneLife会員専用サブスクリプションサービス（GeneLife CONNECT）にお申込みいただいたお客様はGeneLife CONNECTの規程が適用されます。検査後にお申出いただければ、同意の撤回、個人遺伝情報及び個人情報のデータ削除も承っております。<br />
          •個人情報の保護に関する法律<br />
          •人を対象とする生命科学・医学系研究に関する倫理指針<br />
          •個人情報の保護に関する法律についてのガイドライン(通則編、外国にある第三者への提供編、第三者提供時の確認・記録義務編、匿名加工情報編)<br />
          •経済産業分野のうち個人遺伝情報を用いた事業分野における個人情報保護ガイドライン(個人遺伝情報保護ガイドライン) （※2）<br />
          ※2　サービスのうち、経済産業分野を対象とする部分に関して。<br />
          <br />
          ■遺伝子検査サービスの概要<br />
          1.本検査サービスは、検査申込者がだ液を採取し、検査試料として当社に送付することで、人類遺伝学（※3）、多因子疾患の発症リスク（※4）、アルコール・カフェイン等の嗜好性物質に対する反応性（※5）、性格、祖先のルーツなど、検査サービスごとに定められた検査項目に関連する遺伝子について遺伝子検査サービスを行い、健康や美容等のサポートに役立つアドバイスや結果にまつわる情報とともに、検査申込者に検査結果を報告するものです。<br />
          2.解析方法は、全ゲノム解析（WGS: whole genome sequencing）法を用いています。<br />
          3.検査結果の受領方法は、当社の各商品・サービスの標準規格となっており、検査申込者の任意で選べるものではありません。定期的な料金支払を条件としている商品・サービスをご利用されている場合、料金支払が確認できない場合には商品・サービスの提供が中止される場合があります。<br />
          4.検査試料と署名のある検査申込同意書の両方の受領確認が完了しない場合には、遺伝子の解析及び検査結果の報告ができません。受領確認ができなかったことに起因する検査試料の劣化等に関する損害については、当社では責任を負いかねます。また、検査申込者の過失によって検査に必要な部材を紛失した場合、その部材にかかる所定の費用をお支払いいただいた場合のみ、検査に必要な部材をお送りします。<br />
          5.本検査サービスのうち、ClinVar（Clinical Variation）やACMG（American College of Molecular Genetics）などの希少疾患等は人種の影響をほぼ受けないと考えられています。しかし、肥満や肌質等の体質は東アジア人を対象としたものであり、検査結果が全ての人種の方に対して必ずしも該当するとは限りませんので、予めご了承ください。<br />
          6.本検査サービスは、18歳以上の年齢の方を対象としており、当社の個人遺伝情報取扱審査委員会が定める倫理的、社会的な観点から18歳未満の方の検査は行えませんので、予めご了承ください。<br />
          7.通常、本検査サービスは検査試料が当社に到着してから約6～8週間後に検査結果を報告していますが、年末年始やゴールデンウィーク等の長期の休日を挟んだ場合や、甚大なる自然災害等の発生した場合は、報告までにさらに日数がかかる場合があります。また、再検査が必要となった場合、あるいは解析状況等によっても、報告までにさらに日数がかかる場合があります。<br />
          8.本検査サービスは、当社遺伝学研究所もしくは当社が提携している検査受託会社に委託して解析しています。この際、特定の個人を識別できないように検査試料を匿名化（記号化）して取扱います。匿名化した情報で個人情報に該当する場合は、個人情報保護法に基づいて情報の安全管理が図れるよう適切に監督しています。また、遺伝データの保存は国内において行っています。<br />
          9.本検査サービスは研究目的の検査です。遺伝子解析に用いる技術は最新のものを採用していますが、検査結果の正確性、完全性を保証することはいたしかねます。また、採取したDNAの品質や遺伝子配列の特徴により、一部の検査結果が得られない恐れがあることが分かっています。事前にどの遺伝子の結果が出ないか予測することは不可能であることを承知の上、お申し込みください。<br />
          10.検査試料及び抽出したDNAを返却することはありません。検査試料は遺伝子の解析に必要な期間保存しますが、検査結果報告後に当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。抽出したDNAは、検査申込者と当社との契約に基づいて、当社にて適切な方法で保管します。検査申込者と当社との契約が解約された場合は、当社遺伝学研究所もしくは当社が提携している検査受託会社において適切な方法を用いて廃棄します。<br />
          11.本検査サービスは、法医学鑑定（※6）、劣性（潜性）遺伝、常染色体優性（顕性）遺伝の診断目的の遺伝子検査サービスではありません。<br />
          12.血縁者は同じ遺伝子を持っている可能性があり、検査申込者のみでなく本検査サービスを受けていない血縁者の検査結果を想定できる場合がありますが、必ずしも一致するものではありません。<br />
          13.検査結果を知ることにより、精神的な負担となるような場合があることも想定されます。本検査サービスを十分な理解の上で、検査申込者の責任において検査申込みを行ってください。<br />
          14.検査結果が第三者に知られるところとなった場合、検査申込者に対する差別等の社会的不利益がもたらされる可能性や予想外の影響が見込まれます。検査結果の開示は、本検査を十分な理解の上で、必ず検査申込者の判断で行ってください。<br />
          15.本検査サービスの検査項目及び遺伝子は、当社WEBサイト（https://www.genelife.jp）をご確認ください。<br />
          ※3　生理学的な特徴に関連した遺伝子を解析するものです。<br />
          ※4　当社が検査申込者に遺伝学的検査を提供する主たる目的は、健康診断等の他の検査と同様にいくつかある健康維持増進に関する情報のひとつとしてご利用いただくことです。遺伝学的検査は個人の遺伝学的情報を明らかにする遺伝学的検査であり、統計に基づいた①特定の病気の発症リスク、②体質、③その他当社の定める検査項目に関連する当社WEBサイト記載の遺伝子について解析を行います。公になっている論文等に加え、当社の遺伝学、栄養学等の資格及び提携医療機関の資格を有する専門家が監修を行い、遺伝的要因と環境要因の関係を考察して得た健康や美容等のサポートに役立つアドバイスをサービスの一環として提供しています。遺伝性が高い疾患の場合、ClinVar（Clinical Variation）、ACMG（American College of Molecular Genetics）の疾患スクリーニング/専門家パネルの情報が参考とされています。PGx(薬剤応答スクリーニング)の場合はCPIC（Clinical Pharmacogenetics Implementation Consortium）に準拠しています。但し、この検査は診断・診療ではありませんので確定情報にはなりません。肥満・肌・体質・祖先など低侵襲性の約360項目はアプリで結果が確認できますが、ClinVar、ACMG、PGxなどの残りの6,200程度の侵襲性が高い疾患を含むパネルは、アプリを通じて提携医療従事者とのオンラインコンサルテーションを経た後でないとご覧になれません。また、遺伝的な発症の予測リスクは、検査申込者と似た症状を持つ膨大な統計データから算出した値であり、検査申込者が同じ疾患を発症することを断定するものではありません。<br />
          ※5　アルコール・カフェイン等の嗜好性物質に対する反応性には著しい個体差が認められており、この傾向性を予測するために、関連する遺伝子を解析するものです。<br />
          ※6　DNA鑑定、親子・血縁鑑定等<br />
          <br />
          ■情報の取扱いについて<br />
          1.当社における個人遺伝情報及び個人情報（※7）の取扱いは、個人情報保護法、経済産業省が定めているガイドライン（※2）及び一般社団法人遺伝情報取扱協会の自主基準（※2）を遵守しています。<br />
          2.個人遺伝情報及び個人情報は、特定の個人を識別できないように加工して、当該情報を復元して特定の個人を再識別できないようにしたものを分析データとして集積した上で、社会的な必要性等を鑑みて統計として開示されることがあります。<br />
          3.匿名化した情報を精度管理及び品質保証、またはこれらに付随する研究目的等のために利用する場合があります。<br />
          4.検査サービス申込同意書に記入された個人情報は、当社プライバシーポリシーに基づき細心の注意を払って保管し、本人確認や検査申込みの内容確認のために利用します。プライバシーポリシーの詳細は、当社WEBサイト（https://www.genelife.jp）をご確認ください。<br />
          5.当社は、原則として本人の同意がない限り個人遺伝情報及び個人情報を第三者に提供することはありませんが法律に従って開示せざるを得ない場合は、当社の判断により個人遺伝情報及び個人情報を開示する場合があります。<br />
          6.当社は、個人遺伝情報取扱の倫理審査の機能を有する個人遺伝情報取扱審査委員会を設置しており、当社が個人遺伝情報取扱審査委員会に個人遺伝情報取扱の倫理審査の開始を要請した場合、個人遺伝情報取扱審査委員会は公正かつ中立的に当該事業実施の適否の審査を行います。<br />
          7.検査結果に関しては、＜サービス全般及び検査結果に関する窓口＞記載のお問合せ窓口までご連絡ください。尚、検査結果に基づくご質問等、個人遺伝情報に関わる事項については、検査申込者であるご本人からのお問合せに対してのみ回答します。本人確認として、氏名、生年月日、住所、電話番号等を確認させていただきますので、予めご了承ください。また、お問合せの内容によっては、本人確認のためにパスポートや運転免許証の写し等の資料を提出していただく場合がございますので、事前にご用意ください。<br />
          8.検査申込同意書に記載された後、個人情報の訂正や検査同意の撤回を依頼される場合は、＜個人情報に関する窓口＞記載のお問合せ窓口までご連絡ください。その際、検査試料及び検査結果は特定の個人を識別できない状態で廃棄しますが、既にお支払いいただいた検査にかかる部材一式及び検査費用の代金は返金できません。<br />
          9.当社のデータベースで保管されている個人遺伝情報及び個人情報の開示、利用停止、削除をご希望される場合には、＜個人情報に関する窓口＞記載のお問合せ窓口までご連絡ください。但し、個人遺伝情報及び個人情報（検査結果データを含む）が削除された後は、当社WEBサイト上で検査結果の閲覧ができなくなりますので、予めご了承ください。<br />
          10.ご送付いただいた検査試料の被験者の氏名と、検査申込みにかかる記入もしくは登録及び検査申込同意書の氏名が同一だった場合、ご本人の意思により本検査を申し込んだことと見なします。ご本人以外の方が氏名等を偽って使用した場合でも、当社では一切責任を負いかねます。<br />
          ※7　検査申込者が記入もしくは登録した検査申込みにかかる内容（体型や病歴に関するデータを含む）や検査結果等において特定の個人を識別することができるもの<br />
          <br />
          ■インターネット・セキュリティおよび動作推奨環境について<br />
          最新の動作推奨環境およびセキュリティに関しましては、当社WEBサイト（https://www.genelife.jp）をご参照ください。<br />
          <br />
          ■検体試料の返送方法等について<br />
          検査試料の返送は当社指定の方式にてご返送いただきます。ただし、当該返送において遅延、検査試料の劣化、誤配送が発生しないことを当社が保証するものではありません。<br />
          <br />
          ■検査及び検査技術について<br />
          本検査サービスで用いている遺伝子解析機器はIllumina社製のNovaSeq 6000、NovaSeqX PlusもしくはMGI社製のDNBSEQ-T7です。全ゲノム解析において、本機器では30X（カバレッジ）が推奨されており、本プロトコルを当社は厳守いたします。全ゲノム解析では高い品質かつ一定量のDNAを必要としています。試料から解析に必要なDNAが抽出できず、基準を満たす検査が実施できなかった場合でも、再検査は行いません。したがって、だ液の採取においては取り扱い説明をよくお読みいただき、手順に従って採取いただきますようお願いいたします。<br />
          1.結果的に全ての解析結果が得られなかった場合でも、検査申込者から試料が当社遺伝学研究所に届いた時点で、既にお支払いいただいた検査にかかる部材一式及び検査費用の代金は返金できません。<br />
          2.本検査には技術的な限界があり、検査結果から得られる情報が限定的なものであることをご理解の上、お申し込みください。検査結果の正確性、完全性を証明する義務を負うことはいたしかねます。<br />
          <br />
          ■反社会的勢力に係る表明保証<br />
          本検査サービスの利用者は、自らが、集団的又は常習的に違法行為（犯罪行為を含むが、これに限定されない）を行い又はこれを助長するおそれがある団体（以下、「反社会的勢力」という）に該当せず、また、反社会的勢力又はその構成員との間に何らの関係もなく、資金提供その他方法の如何を問わず、これらの者の維持、運営に協力又は関与していないことを表明および保証します。なお、以上について重要な違反事実が判明した場合には、当社は検査サービスを実施しない、もしくは何ら予告なく取りやめることができることとします。<br />
          <br />
          ■免責事項<br />
          1.検査試料の品質や検査技術の限界により、100％正確な検査結果が得られない可能性があります。遺伝子検査サービスには一定の限界があることをご理解ください。<br />
          2.当社が指示した方法に従わずに検査試料の採取を行ったことに起因する検査結果の誤判定や事故、その他の不具合について、一切の責任を負いかねます。<br />
          3.当社が指示した方法に従わずに遺伝子検査サービスキットの部材の誤使用（誤飲等を含む）したことにかかる賠償には応じられません。<br />
          4.口腔内にカフェイン、ポリフェノールなどが付着していたり、疾患（歯周病など）がある場合は、検査を阻害する物質が検査試料に混入するため、繰り返し検査を行っても検査結果が得られないこともありますので、予めご了承ください。<br />
          5.本検査サービスのID及びパスワードは、ご本人が登録の上で厳重に管理していただくようお願いいたします。万が一他者と入れ違いで登録された場合について、当社は一切の責任を負いかねます。<br />
          6.当社が遺伝子の解析過程における事故や不具合を認めた場合を除き、本検査サービスにかかる返金はできません。また、いかなる理由においても、本検査を購入されたお客様にお支払いいただいた遺伝子検査キット代金以上の賠償には応じられません。<br />
          7.検査結果は、健康の維持・増進や生活の充実に関する情報のひとつとして活用していただくことを目的として提供しており、当社の情報提供の目的範囲を超える法的活動、商業活動、営業活動、医療活動等への再利用については、当社は責任を負いかねます。<br />
          8.検査申込者から受領した検査試料や遺伝子検査サービス申込同意書、検査結果の取扱いには細心の注意を払っていますが、次の事由による検査試料や検査申込同意書、検査結果の滅失や、検査申込者からの検査試料返送時における損害等については、当社は損害賠償の責任を負いません。<br />
          ①地震、津波、高潮、大水、暴風雨、地すべり、山崩れ、疫病等その他の天災<br />
          ②ストライキ、サボタージュ<br />
          ③戦争、テロまたは社会的騒擾その他の事変等社会的争乱<br />
          ④核燃料物質に基づく放射性、爆発性その他の有害な特性による事故またはそれに基づく社会的混乱<br />
          ⑤不可抗力による火災<br />
          ⑥予見できない異常な交通障害<br />
          ⑦法令または公権力発動による運送の差止め、開封、没収、差押えまたは第三者への引渡し<br />
          ⑧検査試料返送時における配送会社による故意または過失に起因する検査試料や検査申込同意書、検査結果の遅延・紛失等の事故<br />
          ⑨検査申込者が検査試料の返送用封筒に記載する外装表示の記載過誤、検査申込者の故意または過失に起因する検査試料返送時の事故<br />
          <br />
          ■返品・返金<br />
          未開封の状態に限り、商品到着後8日以内であれば返品・返金に対応いたします。開封後の返品・返金につきましてはお受けすることができません。予めご了承ください。商品に瑕疵がある場合は、返品していただき瑕疵が確認された場合のみ、本検査を購入されたお客様にお支払いいただいた遺伝子検査キット代金の全額返金に応じます。<br />
          <br />
          ■使用期限<br />
          本商品の使用期限はパッケージに記載されている期日となります。使用期限内に検査試料を採取してください。また、試料採取後は採取当日にご返送ください。使用期限内であってもお早めにご使用いただくことをおすすめします。使用期限を過ぎた検査はお受けすることができませんのでご注意ください。使用期限を過ぎたことによる返金・返品はいたしかねますので予めご了承ください。<br />
          <br />
          ■遺伝子検査サービス申込同意書及びプライバシーポリシーの改定について<br />
          遺伝子検査サービス申込同意書の取扱いは、2022年7月1日以降に適用するものとします。当社では、検査申込者の個人情報の保護を図るために、また法令その他の規範の変更に対応するために、遺伝子検査サービス申込同意書、プライバシーポリシーを改定することがあります。特に重要な変更につきましては、当社WEBサイトにおいてお知らせします。<br />
          <br />
          ■準処法・管轄<br />
          本検査は、日本国の法令に準拠し、それに従って解釈するものとし、また、本検査に関する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。<br />
          <br />
          ■個人遺伝情報取扱審査委員会による審査<br />
          当社は、以下の法令等に基づき、ジェネシスヘルスケア株式会社個人遺伝情報取扱審査委員会を設置しております。<br />
          •個人情報の保護に関する法律<br />
          •人を対象とする生命科学・医学系研究に関する倫理指針<br />
          •個人情報の保護に関する法律についてのガイドライン(通則編、外国にある第三者への提供編、第三者提供時の確認・記録義務編、匿名加工情報編)<br />
          •経済産業分野のうち個人遺伝情報を用いた事業分野における個人情報保護ガイドライン(個人遺伝情報保護ガイドライン)<br />
          当該委員会は、当社から独立した立場に立って、科学的、倫理的、法的、社会的、技術的観点から本サービス実施の適否等について審査を行い、適正な事業実施のために意見します。<br />
          <br />
          ■検査結果に関わるコンサルテーションについて<br />
          当社の提供する遺伝子検査サービスに関するご相談をお受けしています。コンサルテーションは、当社提携クリニックの医師及び当社の遺伝学の研究者や専門家等により実施される体制を整備しています。以下よりご連絡ください。<br />
          ＜お問合せ窓口＞<br />
          電話：0120-863-438<br />
          平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          <br />
          ■お問合せ<br />
          ＜サービス全般及び検査結果に関する窓口＞<br />
          電話：0120-863-438  平日10:00～13:00、14:00～17:00（土日祝を除く）<br />
          メールでの問合せ先：infogene@genelife.jp<br />
          <br />
          ＜個人情報に関する窓口＞<br />
          電話：03-5422-8506　平日10:00～17:00（土日祝を除く）<br />
          ジェネシスヘルスケア株式会社　<br />
          〒150-6026 東京都渋谷区恵比寿四丁目20番3号 恵比寿ガーデンプレイスタワー 26階<br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <span className="bold">私は本検査を受けないという選択が可能であることを理解した上で、自らの意思で、採取した検査試料を送付し、検査を行うことおよび遺伝子データ保存・データアップグレード※および研究協力に申込同意します。</span><br />
          ※GeneLife会員専用サブスクリプションサービスを指します。<br />

        </div>
      </div>
    </>
  );



  const getConsentContent = () => {
    switch (selectedKit) {
      case "kit1":
        return wgsConsent;
      case "kit2":
        return wgsConnectConsent;
      default:
        return "検査キットを選択してください。";
    }
  };
  return (
    <div>
      <p>{getConsentContent()}</p>
    </div>
  );
};
export default WgsConsentFormComponent;
